import Loadable from 'react-loadable';

export const PartnerDetailsContainer = Loadable({
  loader: () => import('./PartnerDetails'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/containers/PartnerDetails/index.ts